import { render } from "./AllDataView.vue?vue&type=template&id=33c06cf6"
import script from "./AllDataView.vue?vue&type=script&lang=js"
export * from "./AllDataView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__